import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Logo from '../../componentes/Logo';
import Default from '../../contenedores/Default';

import styles from './styles';
import { setOpcionActiva } from '../../ducks/appbar';

const Dashboard = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const { indexActivo } = useSelector(store => store.appbar);

  useEffect(() => {
    dispatch(setOpcionActiva(indexActivo));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <Default>
      <div className={classes.root}>
        <Logo />
      </div>
    </Default>
  );
}

export default Dashboard;
